import React, { Suspense, useEffect } from 'react';
import './App.css';
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';
import { Grid } from "@mui/material";

const Pagina = React.lazy(() => import('./Pagina/Pagina'));

function App() {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{ xs: 12, sm: 12, md: 12 }}
        >
            <Suspense fallback={<div />}>
                <Pagina />
            </Suspense>
        </Grid>
    );
}

export default App;